import { useEffect, useState } from "react";
import ImageGallery, { ReactImageGalleryItem } from "react-image-gallery";
import { Project, ProjectWithItems } from "../../firebase/db.type";
import { FirebaseService } from "../../firebase/firebase.service";
import "./project.style.scss";

function ProjectList() {
  const [projects, setProjects] = useState<Project[]>([]);
  const [selectedProject, setSelectedProject] =
    useState<ProjectWithItems | null>(null);

  const loadProjects = async (): Promise<void> => {
    try {
      const projectList = await FirebaseService.getProjects();
      setProjects(projectList);
    } catch (error) {
      console.error("Failed to load projects:", error);
    }
  };

  useEffect(() => {
    loadProjects();
  }, []);

  const handleViewProject = async (project: Project): Promise<void> => {
    try {
      const projectWithItems = await FirebaseService.getProjectWithItems(
        project.id
      );
      if (projectWithItems) {
        setSelectedProject(projectWithItems);
      }
    } catch (error) {
      console.error("Failed to load project details:", error);
    }
  };

  return (
    <div className="project-comp">
      <h2 className="title font-archivo">PROJECT</h2>
      <div className="slider grid md:grid-cols-2 lg:grid-cols-3 gap-[33px]">
        {projects?.map((image, index) => {
          return (
            <div
              className="flex flex-col items-center cursor-pointer"
              key={index}
              onClick={() => handleViewProject(image)}
            >
              <div className="w-[316px] h-[250px] flex justify-center rounded-md overflow-hidden">
                <img
                  src={image.imageUrl}
                  alt=""
                  className="w-full h-full hover:scale-110 transition-all ease-in-out"
                />
              </div>
              <p className="text-white font-bold text-[25px] mt-[13px]">
                {image.name}
              </p>
            </div>
          );
        })}

        {selectedProject && !!selectedProject.items.length && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-black bg-opacity-50 rounded-lg p-6 max-w-[80%] h-[80%] overflow-auto">
              <h2 className="text-[32px] text-white font-bold mb-4">
                {selectedProject?.name}
              </h2>
              <div className="w-full h-[300px]">
                <ImageGallery
                  items={
                    selectedProject?.items.map((image) => ({
                      original: image.imageUrl,
                      thumbnail: image.imageUrl,
                    })) as ReactImageGalleryItem[]
                  }
                  showPlayButton={false}
                  showFullscreenButton={false}
                  renderItem={(item) => (
                    <img
                      src={item.original}
                      alt={item.originalAlt}
                      style={{
                        width: "400px",
                        height: "300px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                />
                <div className="flex items-center">
                  <button
                    type="button"
                    className="flex-1 px-4 py-2 border text-white border-gray-300 rounded-lg"
                    onClick={() => setSelectedProject(null)}
                  >
                    Close x
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectList;
